export default __webpack_public_path__ + "static/media/logo.8b7e8d48.jpg";